import styled from "styled-components";
import {brand, radii} from "theme/tokens";

/**
 * Styles for {@link ./SubdomainSettings}, the "Your address" editor
 * (kitecorp/transferify-api-service#350). Externalized per the styling mandate. Renamed to follow its
 * only consumer when ui#529 moved the editor out of its account-page card and into the branding sheet.
 */

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
`;

export const FieldLabel = styled.label`
	font-size: 13px;
	font-weight: 700;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Hint = styled.span`
	font-size: 12.5px;
	line-height: 1.5;
	color: ${({theme}) => theme.tokens.ink2};
`;

export const ErrorText = styled.span`
	font-size: 12.5px;
	line-height: 1.5;
	color: ${brand.error};
`;

/**
 * The label input and its fixed suffix read as one address, so the suffix sits inside the field frame
 * rather than beside it — the sender is choosing one label, not typing a hostname.
 */
export const ClaimField = styled.div`
	display: flex;
	align-items: center;
	min-width: 0;
	flex: 1 1 220px;
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.control};
	background: ${({theme}) => theme.tokens.field};
	overflow: hidden;

	&:focus-within {
		border-color: ${({theme}) => theme.tokens.focusOutline};
	}
`;

export const LabelInput = styled.input`
	flex: 1 1 auto;
	min-width: 0;
	padding: 10px 12px;
	border: 0;
	background: transparent;
	color: ${({theme}) => theme.tokens.ink};
	font-size: 14px;

	&:focus {
		outline: none;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}
`;

export const FieldSuffix = styled.span`
	padding: 0 12px 0 0;
	color: ${({theme}) => theme.tokens.ink2};
	font-size: 13px;
	white-space: nowrap;
`;

/** One claimed origin: the address plus its copy action. */
export const HostRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;

export const HostValue = styled.code`
	flex: 1 1 auto;
	min-width: 0;
	padding: 8px 10px;
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.control};
	background: ${({theme}) => theme.tokens.field};
	color: ${({theme}) => theme.tokens.ink};
	font-size: 13px;
	/* A claimed label can be 63 characters, so the address must wrap inside the sheet rather than widen it. */
	overflow-wrap: anywhere;
`;

/**
 * Replaces the whole editor when the plan does not include a custom address, so nothing is interactive.
 * The sheet decides whether this section is the one that shows it — see {@link ../brand/brandSheetUpsell}.
 */
export const LockedNote = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: ${({theme}) => theme.tokens.ink2};
`;
